import { render } from "./DashboardIcon.vue?vue&type=template&id=fa78eaa2&scoped=true"
const script = {}

import "./DashboardIcon.vue?vue&type=style&index=0&id=fa78eaa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa78eaa2"]])

export default __exports__